import { parse, stringify } from 'qs';
import type { IStringifyOptions } from 'qs';

export const parseSearch = <T extends object = object>(search: string): T =>
  parse(search, { ignoreQueryPrefix: true, comma: true }) as T;

export const encodeQuery = (
  base: string,
  query?: object,
  options: IStringifyOptions = { arrayFormat: 'brackets' }
) => {
  return [base, query && stringify(query, options)].filter(Boolean).join('?');
};
